import { useEffect } from "react";
import { useLayoutChromeStore } from "@/store/layoutChromeStore";

/** PnL-competition campaign pages hide the header and sidebar; restored on unmount. */
export const useCampaignLayoutChrome = (usesPnlCompetitionLayout: boolean): void => {
  const setHideChrome = useLayoutChromeStore((state) => state.setHideChrome);

  useEffect(() => {
    setHideChrome(usesPnlCompetitionLayout);
    return () => setHideChrome(false);
  }, [usesPnlCompetitionLayout, setHideChrome]);
};
